import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        "width",
        "height",
        "aspectRatio",
        "tooltip",
        "submit"
    ];

    submitTimeoutId;

    connect() {
        this.refreshMaxAttributes();
        if (this.hasAspectRatioTarget) {
            const aspectRatioTarget = this.aspectRatioTarget;
            $(this.tooltipTarget).tooltip({
                placement: 'bottom',
                title: function () {
                    return aspectRatioTarget.checked ?
                        this.dataset.checkedTitle :
                        this.dataset.uncheckedTitle;
                }
            });
        }
    };

    get width() {
        return parseFloat(this.widthTarget.value);
    }

    set width(value) {
        this.updateLengthValue(this.widthTarget, value);
    }

    get height() {
        return parseFloat(this.heightTarget.value)
    }

    set height(value) {
        this.updateLengthValue(this.heightTarget, value);
    }

    get aspectRatio() {
        if (this.hasAspectRatioTarget && this.aspectRatioTarget.checked) {
            const aspectRatioValues = this.aspectRatioTarget.value.match(/(\d+):(\d+)/);
            const x = aspectRatioValues[1];
            const y = aspectRatioValues[2];

            return x / y;
        }

        return NaN;
    }

    refreshWidth() {
        if (!isNaN(this.aspectRatio)) {
            this.width = this.height * this.aspectRatio;
        }
        this.refreshMaxAttributes();
    }

    refreshHeight() {
        if (!isNaN(this.aspectRatio)) {
            this.height = this.width / this.aspectRatio;
        }
        this.refreshMaxAttributes();
    }

    refreshMaxAttributes() {
        const maxSmallSide = this.data.get('maxSmallSide');
        const maxLargeSide = this.data.get('maxLargeSide');
        const isPortrait = this.width <= this.height;
        const maxWidth = isPortrait ? maxSmallSide : maxLargeSide;
        const maxHeight = isPortrait ? maxLargeSide : maxSmallSide;
        this.widthTarget.setAttribute('max', maxWidth);
        this.heightTarget.setAttribute('max', maxHeight);
    }

    updateLengthValue(element, updatedValue) {
        const fractionDigits = parseInt(element.dataset.precision);
        element.value = Number(updatedValue).toFixed(fractionDigits);
    }

    toggleSubmit() {
        this.submitTarget.classList.toggle("custom-size-submit--enabled", !this.aspectRatioTarget.checked);
    }

    refreshTooltip() {
        $(this.tooltipTarget).tooltip('show');
    }

    autoSubmit() {
        if (this.hasAspectRatioTarget && this.aspectRatioTarget.checked) {
            clearTimeout(this.submitTimeoutId);
            this.submitTimeoutId = setTimeout(() => {
                if (this.aspectRatioTarget.checked) {
                    this.submitTarget.click();
                }
            }, 500);
        }
    }
}